import {
  Avatar,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import LanguageSwitcher from "../switchers/LanguageSwitcher";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "src/store/api/useAuthStore";
import NotificationAlert from "./NotificationAlert";


function HeaderLinks() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const nameEn = useAuthStore((state) => state.nameEn);
  
  const handleSignOut = () => {
    useAuthStore.getState().clearToken();
    navigate("/home");
  };



  return (
    <>
      <div className="flex items-center mt-4 lg:mt-0 gap-4">
        {/* noti  */}
        <div className="hidden lg:block">
        <NotificationAlert />
        </div>
        {/* lang  */}
        <div className="mt-2 ltr:ml-1.5 rtl:mr-1 hidden lg:block">
          <LanguageSwitcher iconColor="white" />
        </div>
        <div className="mt-2 ltr:ml-1.5 rtl:mr-1 lg:hidden">
          <LanguageSwitcher iconColor="black " />
        </div>

        {/* user  */}
        <div className="px-3 py-3">
          <Dropdown placement="bottom-end">
            <DropdownTrigger>
              <Avatar
                // isBordered
                as="button"
                className="transition-transform"
                color="default"
                size="sm"
                src=""
              />
            </DropdownTrigger>
            <DropdownMenu aria-label="Profile Actions" variant="flat">
              <DropdownItem key="profile" className="h-14 gap-2">
                <p className="font-semibold">
                  {t("Hello")}
                  {nameEn}
                </p>
              </DropdownItem>
              {/* <DropdownItem key="settings">My Settings</DropdownItem>
                    <DropdownItem key="help_and_feedback">
                      Help & Feedback
                    </DropdownItem> */}
              <DropdownItem key="logout" color="danger" onClick={handleSignOut}>
                {t("SignOut")}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </>
  );
}

export default HeaderLinks;